'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const styleEncapsulation = require('@zapier/style-encapsulation');

const Styles = styleEncapsulation.labelStyles("ZapierLogoSymbol", {
  root: { display: "block" }
});

exports.Styles = Styles;
//# sourceMappingURL=Styles.cjs.js.map
